import React, { useContext, useState } from 'react';
import { FormContext } from '../metadata/MDForm';
import { ModelContext } from '../metadata/ModelSource';
import { formatMoneyAmount } from '../../utils/formatUtils';

const styles = {
  container: {
    display: 'flex',
    justifyContent: '-webkit-right',
    alignContent: '-webkit-right',
  },
  text: {
    margin: 0,
    fontWeight: 'bold'
  }
};

export const PremiumSumTwoCoverage = ({ attr, cd1, cd2 }) => {
  const form = useContext(FormContext);
  const model = useContext(ModelContext);

  const prefix = form.prefix;
  const risks = form.getValue('risks');

  let sum = 0;

  if (risks !== undefined) {
    risks.forEach((risk, index) => {
      const premiumAmtCd1 = form.getValue(
        `risks[${index}].coverages{coverageCd:${cd1}}.writtenPremiumAmt`
      );
	  const premiumAmtCd2 = form.getValue(
        `risks[${index}].coverages{coverageCd:${cd2}}.writtenPremiumAmt`
      );

      if (premiumAmtCd1 === undefined || premiumAmtCd2 === undefined) {
        return sum;
      }
	  
	  sum = parseFloat(premiumAmtCd1) + parseFloat(premiumAmtCd2) + sum;
      return sum;
    });
  } else {
    const riskIndex = parseInt(
      prefix.substring(prefix.lastIndexOf('[') + 1, prefix.lastIndexOf(']'))
    );
    const value1 = model.getValue(
      `${prefix}coverages{coverageCd:${cd1}}.writtenPremiumAmt`
    );
	const value2 = model.getValue(
      `${prefix}coverages{coverageCd:${cd2}}.writtenPremiumAmt`
    );
    const formattedValue = formatMoneyAmount( ( parseFloat(value1) + parseFloat(value2) ) );    
    sum = formattedValue;
  }

  const formatValue = value => {
    if (value !== undefined || value !== 0) {
      return `${formatMoneyAmount(value)}`;
    } else {
      return '$0.00';
    }
  };

  if (sum == '$NaN') {
    sum = '$0.00';
  }

  return (
    <div style={styles.container}>
      {risks !== undefined ? (
        <p style={styles.text}>{formatValue(sum)}</p>
      ) : (
        <p style={styles.text}>{sum}</p>
      )}
    </div>
  );
};